import Section from '~/components/Section';

interface Props {
  title: string;
  text: string;
}

const EmptyState = ({ title, text }: Props) => {
  return (
    <Section title={title}>
      <p className="mt-4 py-4 text-left text-gray-500 lg:py-8 lg:text-center">{text}</p>
    </Section>
  );
};

export default EmptyState;
